import { useTranslation } from 'libs/i18n';

import { Field, useFormContext } from '../../../forms/orderForm';
import { OrderSection } from '../../OrderSection';

import { useAdditionalParametersSection } from './useAdditionalParametersSection';

export const AdditionalParametersSection = () => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { isRequired } = useAdditionalParametersSection();

  return (
    <OrderSection
      fields={[
        <Field.DatePicker
          disableFuture
          fullWidth
          disabled={readOnly ? false : !isRequired}
          label={t(
            'account.order.sections.additionalParametersSection.fields.transactionDate.label'
          )}
          name="additionalParameters.transactionDate"
          placeholder={
            isRequired
              ? t(
                  'account.order.sections.additionalParametersSection.fields.transactionDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequired}
        />,
        <Field.DatePicker
          fullWidth
          disabled={readOnly ? false : !isRequired}
          disableFuture={false}
          label={t(
            'account.order.sections.additionalParametersSection.fields.settlementDate.label'
          )}
          minDate={new Date()}
          name="additionalParameters.settlementDate"
          placeholder={
            isRequired
              ? t(
                  'account.order.sections.additionalParametersSection.fields.settlementDate.placeholder'
                )
              : undefined
          }
          showRequiredMark={isRequired}
        />,
      ]}
      title={t('account.order.sections.additionalParametersSection.title')}
    />
  );
};
